// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"60":"a8bee09f","897":"edc5f5f7"}[chunkId] + ".css";
};